import { useReportStore } from '@/modules/report/useReportsStore'
import { Progress } from '@/modules/shared/components/ui/progress'
import { Separator } from '@/modules/shared/components/ui/separator'
import { priceFormatter } from '@/modules/shared/utils/formatter'

export function CardReportTarget() {
	const jsonSalesGoal = useReportStore((state) => state.jsonSalesGoal)

	let targetPercent = 0
	if (jsonSalesGoal?.resumo?.valor > 0) {
		targetPercent = Math.round(
			(jsonSalesGoal?.resumo?.valor * 100) / jsonSalesGoal?.resumo?.valorCota,
		)
	}

	return (
		<div className="w-1/2 bg-blue-500 rounded-md border border-gray-100 shadow-md p-2 text-white text-sm">
			<div className="flex justify-between mb-2">
				<p>Meta</p>
				<div className="w-2/6 text-center">
					<Progress className="h-3" value={targetPercent} />
					<p className="text-sm">{targetPercent}%</p>
				</div>
			</div>

			<Separator />

			<div className="text-center pt-3">
				<p>
					<strong>
						{priceFormatter.format(jsonSalesGoal?.resumo?.valorCota)}
					</strong>
				</p>
			</div>

			<div className="flex justify-between items-end">
				<div>
					<p>Dias Rest.</p>
					<p>{jsonSalesGoal?.resumo?.diasFaltantes}</p>
				</div>
				<div>
					<p>Meta Dia</p>
					<p>
						{priceFormatter
							.format(jsonSalesGoal?.resumo?.valorDia)
							.replace('R$', '')}
					</p>
				</div>
			</div>
		</div>
	)
}
